import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b1c6d0ee&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "../../../styles/button.less?vue&type=style&index=0&id=b1c6d0ee&lang=less&scoped=true&"
import style1 from "./index.vue?vue&type=style&index=1&id=b1c6d0ee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1c6d0ee",
  null
  
)

export default component.exports